/**
 * The inverse of `ProtectedRoute` — wraps routes only a logged-out
 * visitor should see (Login). An already-authenticated user hitting
 * `/login` directly is sent to the app shell instead of shown the
 * form again.
 */
import type { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@store/auth.store';

export function GuestRoute(): JSX.Element {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isTokenExpired = useAuthStore((state) => state.isTokenExpired);

  if (isAuthenticated && !isTokenExpired()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
